import React, { FC, useEffect } from 'react';
import { Form, InputNumber } from 'antd';
import moment from 'moment';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { getCycleRangeText, transformBudgetAllCycles } from '../../utils/BudgetUtils';

const BudgetForEachCycleFormField: FC<any> = ({
	form,
	currency,
	initialValue,
}): React.ReactElement => {
	const { setFieldsValue } = form;

	const allCycles = Form.useWatch('allCycles', form);
	const budgetPerPeriod = Form.useWatch('budgetPerPeriod', form);

	useEffect(() => {
		if (allCycles && allCycles.length) {
			setFieldsValue({
				budgetPerPeriod: transformBudgetAllCycles(allCycles).map((cycle) => {
					const existingBudgetValue = (initialValue || []).find((_) => _.cycle === cycle.cycle);
					return {
						...cycle,
						budget: nullSafeGet('budget', existingBudgetValue),
					};
				}),
			});
		}
	}, [allCycles, initialValue, setFieldsValue]);

	return (
		<Form.List name="budgetPerPeriod">
			{(fields) => (
				<>
					{fields.map(({ key, name, ...restField }, index) => {
						const cycle = nullSafeGet(`${name}`, budgetPerPeriod);
						return cycle ? (
							<div key={key} className="flex w-full flex-row items-center justify-between gap-4">
								<strong className="mb-6">Period {index + 1}</strong>
								<div className="mb-6">{getCycleRangeText(cycle)}</div>
								<Form.Item
									{...restField}
									name={[name, 'budget']}
									rules={[{ required: true, message: 'Enter a budget' }]}
								>
									<InputNumber
										style={{ width: 150 }}
										placeholder="Budget"
										addonAfter={currency.id}
									/>
								</Form.Item>
							</div>
						) : null;
					})}
				</>
			)}
		</Form.List>
	);
};

export default BudgetForEachCycleFormField;
